type DatetimeType = {
	year?: number;
	month?: number;
	day?: number;
	hour?: number;
	minute?: number;
	second?: number;
}

export function cpfCnpjNoMask(cpfCnpj: string) {
	let newCpf = cpfCnpj.replaceAll(".", "");
	newCpf = newCpf.replaceAll("-", "");
	newCpf = newCpf.replaceAll("/", "");
	return newCpf;
}

export function telephoneNoMask(telephone: string) {
	let newTelephone = telephone.replaceAll("(", "");
	newTelephone = newTelephone.replaceAll(")", "");
	newTelephone = newTelephone.replaceAll(" ", "");
	newTelephone = newTelephone.replaceAll("-", "");
	return newTelephone;
}

export function cepNoMask(cep: string) {
	if (cep) {
		let newCep = cep.replaceAll("-", "");
		return newCep;
	} else {
		return '';
	}
}

export function datetimeToDateBR(datetime: string) {
	return `${datetime.substring(8, 10)}/${datetime.substring(
		5,
		7
	)}/${datetime.substring(0, 4)}`;
}

export function datetimeToDatetimeBR(datetime: string, sumDate?: DatetimeType) {
	const day = parseInt(datetime.substring(8, 10)) + (sumDate?.day ? +sumDate.day : 0);
	const month = parseInt(datetime.substring(5, 7)) + (sumDate?.month ? +sumDate.month : 0)
	const year = parseInt(datetime.substring(0, 4)) + (sumDate?.year ? +sumDate.year : 0)
	const hour = parseInt(datetime.substring(11, 13)) + (sumDate?.hour ? +sumDate.hour : 0)
	const minute = parseInt(datetime.substring(14, 16)) + (sumDate?.minute ? +sumDate.minute : 0)
	const second = parseInt(datetime.substring(17, 19)) + (sumDate?.second ? +sumDate.second : 0);
	return `
	${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}
	 ${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}:${second < 10 ? '0' + second : second}
	`;
}


export function datetimeToDateSendOrder(datetime: string) {
	if (!datetime) return '';

	// Remove time if present
	const datePart = datetime.split(' ')[0].split('T')[0];

	// yyyy-mm-dd
	const isoMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (isoMatch) {
		return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
	}

	// dd/mm/yyyy
	const brMatch = datePart.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
	if (brMatch) {
		return `${brMatch[3]}-${brMatch[2]}-${brMatch[1]}`;
	}

	// fallback: try Date parse
	const d = new Date(datetime);
	if (!isNaN(d.getTime())) {
		const y = d.getFullYear();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return `${y}-${m}-${day}`;
	}

	return '';
}

export function datetimeToDateUS(datetime: string) {
	return `${datetime.substring(6, 10)}-${datetime.substring(
		3,
		5
	)}-${datetime.substring(0, 2)}`;
}

export function dateBRToDateISO(datetime: string) {
	return new Date(
		parseInt(datetime.substring(6, 10)),
		parseInt(datetime.substring(3, 5)) - 1,
		parseInt(datetime.substring(0, 2))
	);
}

export function maskCardNumber(cardNumber: string) {
	return `**** **** **** ${cardNumber.substring(12, cardNumber.length)}`;
}

export function cnpjMask(v: any) {
	v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
	v = v.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
	v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
	v = v.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
	v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
	return v;
}

export function cpfMask(v: any) {
	if(v){
		v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
		v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
		v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
		//de novo (para o segundo bloco de números)
		v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
		return v;
	} else return ''
}

export function rtcToText(content: string) {
	let contentFormated = content.replace(/\\par[d]?/g, "<br>");
	contentFormated = contentFormated.replace(/\n([0-9]*)?/g, "<br>");

	contentFormated = contentFormated.replace(/\\bullet\\tab/ig, "&nbsp;-");
	contentFormated = contentFormated.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "").trim()

	contentFormated = contentFormated.replace(/\\'e3/g, "ã");
	contentFormated = contentFormated.replace(/\\'c3/g, "Ã");
	contentFormated = contentFormated.replace(/\\'e1/g, "á");
	contentFormated = contentFormated.replace(/\\'c1/g, "Á");

	contentFormated = contentFormated.replace(/\\'ea/g, "ê");
	contentFormated = contentFormated.replace(/\\'ca/g, "Ê");
	contentFormated = contentFormated.replace(/\\'e9/g, "é");
	contentFormated = contentFormated.replace(/\\'c9/g, "É");

	contentFormated = contentFormated.replace(/\\'ed/g, "í");

	contentFormated = contentFormated.replace(/\\'f3/g, "ó");
	contentFormated = contentFormated.replace(/\\'f5/g, "õ");

	contentFormated = contentFormated.replace(/\\'e7/g, "ç");
	contentFormated = contentFormated.replace(/\\'c7/g, "Ç");

	return contentFormated;
}

export function parseJsonChatResponse(jsonContent: string): string {
  try {
    // Tenta fazer o parse do JSON
    const parsedData = JSON.parse(jsonContent);
    
    // Verifica se é o formato esperado com humanizedAnswer
    if (parsedData.humanizedAnswer || 
        (parsedData.result && parsedData.result.humanizedAnswer)) {
      
      let humanizedAnswer = parsedData.humanizedAnswer || 
                            parsedData.result.humanizedAnswer;
      
      // Se a humanizedAnswer for uma string que contém JSON
      if (typeof humanizedAnswer === 'string' && 
          (humanizedAnswer.startsWith('[') || humanizedAnswer.startsWith('{'))) {
        try {
          // Converte a string JSON em objeto
          const answerItems = JSON.parse(humanizedAnswer);
          
          // Formata a resposta baseada no conteúdo
          if (Array.isArray(answerItems)) {
            // Se for um array de itens, cria uma representação em HTML
            let formattedOutput = '';
            
            answerItems.forEach((item, index) => {
              if (item.message) {
                // Substitui quebras de linha por tags <br>
                const message = item.message.replace(/\\n/g, '<br>');
                
                formattedOutput += `<div class="chat-item">
                  ${item.image ? `<img src="${item.image}" alt="Produto ${index + 1}" class="product-image">` : ''}
                  <div class="message-content">
                    ${message}
                  </div>
                  ${item.webapp ? `<a href="${item.webapp}" class="product-link">Ver produto</a>` : ''}
                </div>`;
              }
            });
            
            return formattedOutput;
          } else if (typeof answerItems === 'object') {
            // Se for um único objeto
            const message = answerItems.message ? 
                           answerItems.message.replace(/\\n/g, '<br>') : 
                           JSON.stringify(answerItems);
                           
            return `<div class="chat-item">
              ${answerItems.image ? `<img src="${answerItems.image}" alt="Produto" class="product-image">` : ''}
              <div class="message-content">
                ${message}
              </div>
              ${answerItems.webapp ? `<a href="${answerItems.webapp}" class="product-link">Ver produto</a>` : ''}
            </div>`;
          }
        } catch (innerError) {
          console.error('Erro ao processar humanizedAnswer como JSON:', innerError);
          // Se falhar o parse do JSON interno, retorna o texto bruto com quebras de linha
          return humanizedAnswer.replace(/\\n/g, '<br>');
        }
      }
      
      // Caso não seja um JSON válido dentro da resposta, retorna o texto com quebras de linha formatadas
      return typeof humanizedAnswer === 'string' ? 
             humanizedAnswer.replace(/\\n/g, '<br>') : 
             JSON.stringify(humanizedAnswer);
    }
    
    // Se não tiver o formato esperado, retorna o JSON formatado como string
    return JSON.stringify(parsedData, null, 2).replace(/\\n/g, '<br>');
    
  } catch (error) {
    console.error('Erro ao processar resposta JSON:', error);
    // Se não for um JSON válido, aplica a função original
    return rtcToTextChatIA(jsonContent);
  }
}

// Atualiza a função original para usar a nova função quando detectar JSON
export function rtcToTextChatIA(content: string): string {
  // Verifica se o conteúdo parece ser um JSON
  if ((content.trim().startsWith('{') && content.trim().endsWith('}')) || 
      (content.trim().startsWith('[') && content.trim().endsWith(']'))) {
    try {
      return parseJsonChatResponse(content);
    } catch (e) {
      console.log('Falha ao processar como JSON, processando como texto normal');
      // Se falhar, continua com a implementação original
    }
  }
  
  // Implementação original para textos não-JSON
  let contentFormated = content.replace(/\\par[d]?/g, "<br>");
  contentFormated = contentFormated.replace(/\n([0-9]*)?/g, "<br>");

  contentFormated = contentFormated.replace(/\\bullet\\tab/ig, "&nbsp;-");
  contentFormated = contentFormated.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "").trim()

  contentFormated = contentFormated.replace(/\\'e3/g, "ã");
  contentFormated = contentFormated.replace(/\\'c3/g, "Ã");
  contentFormated = contentFormated.replace(/\\'e1/g, "á");
  contentFormated = contentFormated.replace(/\\'c1/g, "Á");

  contentFormated = contentFormated.replace(/\\'ea/g, "ê");
  contentFormated = contentFormated.replace(/\\'ca/g, "Ê");
  contentFormated = contentFormated.replace(/\\'e9/g, "é");
  contentFormated = contentFormated.replace(/\\'c9/g, "É");

  contentFormated = contentFormated.replace(/\\'ed/g, "í");

  contentFormated = contentFormated.replace(/\\'f3/g, "ó");
  contentFormated = contentFormated.replace(/\\'f5/g, "õ");

  contentFormated = contentFormated.replace(/\\'e7/g, "ç");
  contentFormated = contentFormated.replace(/\\'c7/g, "Ç");

  return contentFormated;
}


export function telephoneToMask(numero: string) {
	// Remove todos os caracteres não numéricos do número de telefone
	const numerosApenas = numero.replace(/\D/g, '');

	// Verifica se o número possui 11 dígitos (incluindo o DDD) e aplica a máscara correspondente
	if (numerosApenas.length === 11) {
		return numerosApenas.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
	} else if (numerosApenas.length === 10) {
		return numerosApenas.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
	} else {
		// Retorna o número sem alterações se não puder ser formatado
		return numero;
	}
}

export function cepToMask(cep:string) {
	// Remove caracteres não numéricos
	cep = cep.replace(/\D/g, '');

	// Adiciona a máscara
	cep = cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');

	return cep;
}